import React from 'react'
import { hydrateRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import analytics from '@adc/analytics'
import {
  ApplicationContextProvider,
  ANNOUNCEMENT_DISMISS_COOKIE_KEY,
} from '@adc/ui-adc'
import config from '@adc/configment'
import * as blueprint from '@adc/blueprint'
import RouterApp from '../common/containers/routerApp'
import configureStore from '../common/store'

analytics.init(
  window.CONFIGS,
  analytics.createAnalyticsContext(
    window.INITIAL_STATE.shellState ||
      window.INITIAL_STATE.application ||
      window.INITIAL_STATE
  )
)

const readCookie = name => {
  const match = document.cookie
    .split('; ')
    .find(row => row.startsWith(`${name}=`))
  return match ? decodeURIComponent(match.split('=')[1]) : undefined
}

// NOTE: This is finally my chance to get some routing into ApplicationShell!
if (!document.baseURI.endsWith('/offer')) {
  const store = configureStore(window.INITIAL_STATE.shellState)

  const contextProps = {
    graphWebsocket: new blueprint.primitives.GraphWebsocket(),
  }

  const ssrHints = {
    announcementDismissedFingerprint: readCookie(
      ANNOUNCEMENT_DISMISS_COOKIE_KEY
    ),
  }

  hydrateRoot(
    window.ROOT_DOM_MOUNT,
    <ApplicationContextProvider {...contextProps}>
      <Provider store={store}>
        <BrowserRouter basename={config.get('URL_BASE_PREFIX')}>
          <RouterApp ssrHints={ssrHints} />
        </BrowserRouter>
      </Provider>
    </ApplicationContextProvider>
  )
}
